import React from 'react';

import { useObserver } from 'mobx-react-lite';
import { Select, Input } from '@bringg/react-components';
import _map from 'lodash/map';
import _join from 'lodash/join';
import isEmpty from 'lodash/isEmpty';
import { useTranslation } from 'react-i18next';
import { useWebhooksApiStore, Webhook } from '@bringg-frontend/webhooks-api-internal-stores';

interface Props {
	webhook: Webhook;
}

const mapConditionFields = (key, webhooksConfigByKey) => {
	const fields = webhooksConfigByKey[key] && webhooksConfigByKey[key].fields;
	return _map(fields, field => ({
		id: field.key,
		name: field.title
	}));
};

const mapConditionFieldsByFlexible = (fields: string[][]) => {
	return _map(fields, fieldChain => {
		const field = _join(fieldChain, '.');
		return {
			id: field,
			name: field
		};
	});
};

const WebhooksEditCondition: React.FC<Props> = ({ webhook }) => {
	const { t } = useTranslation();
	const { webhooksAppStore } = useWebhooksApiStore();

	return useObserver(() => {
		const conditionFields = webhook.isFlexible
			? mapConditionFieldsByFlexible(webhook.selectedFields)
			: mapConditionFields(webhook.key, webhooksAppStore.applicationConfig);
		const requiredError =
			webhook.conditionKey && isEmpty(webhook.conditionValue)
				? t('WEBHOOK_APP.MODAL.REQUIRED_ERROR', { defaultValue: 'Required' })
				: undefined;

		return (
			<>
				<div className="filter-type">
					<Select
						showSearch
						className="select-max-width"
						placeholder={t('WEBHOOK_APP.MODAL.WEBHOOK_FILTER_FIELD', {
							defaultValue: 'Filter by task field'
						})}
						allowClear={true}
						value={webhook.conditionKey}
						onChange={webhook.setConditionKey}
						options={conditionFields}
					/>
				</div>
				<div className="filter-text">{t('WEBHOOK_APP.MODAL.EQUALS_TEXT', { defaultValue: 'equals' })}</div>
				<div className="filter-value">
					<Input
						placeholder={t('WEBHOOK_APP.MODAL.VALUE_FIELD', { defaultValue: 'Value' })}
						error={requiredError}
						onChange={e => webhook.setConditionValue(e.target.value)}
						value={webhook.conditionValue || ''}
					/>
				</div>
			</>
		);
	});
};

export default WebhooksEditCondition;
